module.exports = __webpack_public_path__ + "img/icon_success.f757a0c1.png";